import * as yup from "yup";

export const modeOfPaymentSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
});
